import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Link } from 'react-router-dom';

import mixpanel from 'mixpanel-browser';

// Firebase
import { db } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

// Redux
import { connect } from 'react-redux';

//  Actions - imported
import { editUserName, editUserBio } from '../actions/authActions';
import { setPage, toggleAuthModal, add_To_Recent_History, togglePostModal } from '../actions/navActions';
import { getProfileById } from '../actions/authActions';
import { getPostsByUserId, getUserPhotos, setPosts, getLikedPosts, getReviewsByUserId, set_ShowBottomSpinner, getUserTotalPosts_Helper } from '../actions/postActions';
// wrapper layout
import Layout from '../components/layout/Layout';

// Components
import { Button } from '@material-ui/core';
import Spinner from '../components/common/Spinner';
import ProfileHeader from '../components/Profile/ProfileHeader';
import Post from '../components/Post/Post';
import Image_Block from './MediaPage/Image_Block';
import Empty_Card from './MediaPage/Empty_Card';

// Icons
import PostAddIcon from '@material-ui/icons/PostAdd';
import AddIcon from '@material-ui/icons/Add';
import CreateIcon from '@material-ui/icons/Create';

// Edit profile - page
import ProfileEdit from '../components/Profile/ProfileEdit';
import TweetBox from '../components/TweetBox/TweetBox';
import Review from '../components/Reviews/Review';

const initialState = {
    first_name: '',
    last_name: '',
    bio: ''
};

const Profile = ({ 
    setPage,
    toggleAuthModal,
    togglePostModal,
    add_To_Recent_History,
    auth: { 
        user, 
        profileUser,
        loading,
        profile_loading
    }, 
    post,
    nav: {
        postModal,
        website,
        website_loading
    },
    getPostsByUserId, 
    getUserPhotos,
    getLikedPosts,
    getReviewsByUserId,
    set_ShowBottomSpinner,
    setPosts,
    getProfileById,
    editUserName, 
    editUserBio,
    match,
    history
}) => {

    // Analytics 
    const [sentMixpanel, setSentMixpanel] = useState(false);

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Load correct user 
    const [gotModalUser, setGotModalUser] = useState(false);

    // Check if user is verified
    const [checkedVerification, setCheckedVerification] = useState(false);
    const [checkedVerification_schoolEmail, setCheckedVerification_schoolEmail] = useState(false);

    // Posts
    const [postList, setPostList] = useState([]);
    const [gotPosts, setGotPosts] = useState(false);

    // Get Post Total 
    const [gotPostTotal, setGotPostTotal] = useState(false);
    const [totalPosts, setTotalPosts] = useState(0);

    // Scroll direction - for displaying top nav bar
    const [scrollDirection, setScrollDirection] = useState("up");
    const [oldScrollY, setOldScrollY] = useState(window.scrollY);

    // Temporarily disable to load more function to avoid duplicate fetch requests
    const [canLoadMore, setCanLoadMore] = useState(true);

    // Get the "show" and "redirect" parameters from the URL
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const filter = url.searchParams.get("show");
    const showMessageModal = url.searchParams.get("redirect");
    const hostname = window.location.hostname;

    const SPACE_HEIGHT = 250; // Hieght of className 'no-rides' which is a spacer to make sure user can always scroll down

    // Firebase collection ref
    const postsCollectionRef = collection(db, "posts");

    // Determine mobile and tablet screen sizes
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    useEffect(() => {
        
        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    useEffect(() => {

        // Set the current page to 'profile'
        setPage('profile');
        
        add_To_Recent_History(url.pathname);  // current url

        // Get the user by username from the route parameter
        if(match.params.id) {
            if(match.params.id !== profileUser?._id) { // This conditional prevents the program from calling getProfileById() twice
                getProfileById(match.params.id);
            }
        } else {
            if(!loading && user) {
                getProfileById(user._id);
            }
        }
    }, [match.params.id, user, filter])

    useEffect(() => {
        setGotPosts(false);
        fetchUserPosts();

    }, [profileUser, filter, website_loading]);

    useEffect(() => {

        renderPostList();

    }, [post.posts, canLoadMore]);

    // --- Profile TABS logic ---

    const fetchUserPosts = () => {

        if(profileUser && !website_loading) {
            if(filter) {

                // Load posts with photos if on the profile's 'photos' tab
                if(filter === 'photos') {

                    getUserPhotos({ user_id: profileUser._id, website })
                    setGotPosts(true);
                } else if(filter === 'reviews') {

                    getReviewsByUserId({ user_id: profileUser._id });
                    setGotPosts(true);
                    
                }
                
                
            } else {

                getPostsByUserId({ user_id: profileUser._id, website });
                setGotPosts(true);
            }

            // Update the user's total posts
            handleGetTotalPostsCount();
            // if(profileUser.totalPosts) {
            //     setTotalPosts(profileUser.totalPosts);
            // }
        }
    }

    const handleGetTotalPostsCount = async () => {
        if(profileUser && !website_loading) {
            const totalPosts = await getUserTotalPosts_Helper({ user_id: profileUser?._id, website});
            setTotalPosts(totalPosts)
        }
    }

    // --- END: Profile TABS ---

    const toggleEdit = () => {
        // setEditMode(!editMode);
        window.location.href = "/profile/edit";
        // history.push('/profile/edit')
    }

    // const getPostTotal = async id => {
    //     const postTotal = await axios.get(`/api/posts/user/number-of-posts/${profileUser._id}`);

    //     setTotalPosts(postTotal.data);

    //     setGotPostTotal(true);
    // }

    // if(!loading && user && !gotUser) {
    //     getUserByUsername(match.params.username);
    //     setGotUser(true);
    // }

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    // Infinite scroll AND handle top nav bar display
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight} = e.target

        const newScrollY = offsetHeight + scrollTop;

        // --- Handle top nav bar display
        if(isMobile) {
            if(oldScrollY < newScrollY){

                // scrolling down - hide top nav
                setScrollDirection("down");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.remove("active");
                }
                
            } else {
    
                // scrolling up - show top nav
                setScrollDirection("up");
    
                if(document.getElementById('feed-header') !== null) {
                    document.getElementById('feed-header').classList.add("active");
                }
            }
        }
        // --- END Handle top nav bar display

        // update the scroll position for future comparison
        setOldScrollY(newScrollY)

        // Check if the user has scrolled to the bottom of the content and conditions for loading more posts are met
        if (newScrollY >= scrollHeight - (SPACE_HEIGHT+1) && !post.show_bottom_spinner && !post.no_more_posts && post.posts.length > 0 && canLoadMore) {
            loadMore(post.last_page_doc);
        }
    }

    const loadMore = async (lastPage_doc) => {
        if(website_loading) return; // wait for website check to finish, so query doesn't fetch posts from main website on a custom url
        try {
            // Temporarily disable to load more function to avoid duplicate fetch requests
            setCanLoadMore(false);

            // Show spinner
            set_ShowBottomSpinner(true);

            if(filter) {

                // Load posts with photos if on the profile's 'photos' tab
                if(filter === 'photos') {

                    await getUserPhotos({ user_id: profileUser._id, lastPageDoc: lastPage_doc, website });

                } else if(filter === 'reviews') {

                    await getReviewsByUserId({ user_id: profileUser._id, lastPageDoc: lastPage_doc });
                    
                }
                
                
            } else {
                await getPostsByUserId({ user_id: profileUser._id, lastPageDoc: lastPage_doc, website })
            }
        } catch (error) {
            console.log("ERROR loading more", error);
        } finally {
            // Re-enable the load more capabilty
            setCanLoadMore(true);
        }
    }

    // Check if user is verified. If no redirect to verify page
    if(user && !user.verified && !checkedVerification) {
        window.location.href = '/verify';

        setCheckedVerification(true);
    }

    const renderPostList = async () => {
        setPostList([]);

        if((post.posts === null && profile_loading) || !gotPosts) {
            setPostList([(
                <div className="no-rides">
                    <Spinner />
                </div>
            )])
        }
        else { 
            if(post.posts.length > 0) {
                post.posts.map(post_doc => {
                    if (filter === 'photos') {
                        setPostList(postList => [...postList, (
                            <Image_Block key={post_doc._id} detailPost={post_doc} />
                        )])
                    } else {
                        const renderPostRecursive = (postComments, parentPost) => {
                        
                            const lastComment = postComments[postComments.length - 1]; // Get the last comment
        
                            return (
                                <Fragment>
                                    {filter === 'reviews' ? (
                                        <Review key={lastComment._id} postDoc={lastComment} parentPost={parentPost} isComment />
                                    ) : (
                                        <Post key={lastComment._id} postDoc={lastComment} parentPost={parentPost} />
                                    )}
        
                                    {/* Recursive call to render comments of comments */}
                                    {lastComment.commentsOfComments && lastComment.commentsOfComments.length > 0 && (
                                        <div className="comments-of-comments">
                                        {renderPostRecursive(lastComment.commentsOfComments, lastComment)}
                                        </div>
                                    )}
                                </Fragment>
                            );
        
                        };
        
                        if(post_doc.commentsOfComments && post_doc.commentsOfComments.length > 0) {
                            setPostList(postList => [...postList, (
                                <div className='post_container'>
                                    {filter === 'reviews' ? (
                                        <Review key={post_doc._id} postDoc={post_doc} />
                                    ) : (
                                        <Post key={post_doc._id} postDoc={post_doc} />
                                    )}
        
                                    {renderPostRecursive(post_doc.commentsOfComments, post_doc)}
                                </div>
                            )])
                        } else {
                            if(filter === 'reviews') {
                                setPostList(postList => [...postList, (
                                    <Review key={post_doc._id} postDoc={post_doc} />
                                )])
                            } else {
                                setPostList(postList => [...postList, (
                                    <Post key={post_doc._id} postDoc={post_doc} />
                                )])
                            }
                        }
                    }
                }) 
            } else {
                if (filter === 'photos') {
                    setPostList(postList => [...postList, (
                        <div className="no-rides">
                            <h1>No Photos / Videos</h1>
                        </div>
                    )])
                } else if (filter === 'reviews') {
                    setPostList(postList => [...postList, (
                        <div className="no-rides">
                            <h1>No Reviews</h1>
                        </div>
                    )])
                } else {
                    setPostList(postList => [...postList, (
                        <div className="no-rides">
                            <h1>No Posts</h1>
                        </div>
                    )])
                }
                
            }
        } 

        setGotPosts(true);
    }

    // Initialize Mixpanel and track Page View
    const handleMixpanel = () => {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_ID);
        mixpanel.track("Profile View");
    }

    // Check if the code is running in production and Mixpanel event hasn't been sent yet
    if(process.env.NODE_ENV === 'production' && !sentMixpanel && !hostname.includes('xbuysell')) {
        
        // Initialize Mixpanel and track the event
        handleMixpanel();

        // Set the flag to indicate that Mixpanel event has been sent
        setSentMixpanel(true);
    }

    return (
        <Fragment>
            <Layout handleScroll={handleScroll} page="profile" user={profileUser} totalPosts={totalPosts}>

                {profile_loading ? (
                    <Spinner />
                ) : !profileUser ? (
                    <div className="no-post">
                        <h1>This page doesn’t exist. </h1>
                        <p>Try searching for something else.</p>
                        <Button  
                            onClick={() => window.location ='/search'}
                            className="noChats__btn"
                        >
                            Search
                        </Button>
                    </div>
                ) : (
                    <Fragment>
                        {/* Render the profile header */}
                        <ProfileHeader showMessageModal={showMessageModal} toggleEdit={toggleEdit} history={history} />

                        {/* Render TweetBox component if user is authenticated and postModal is false */}
                        {(filter === 'reviews' && !loading && user?._id !== profileUser?._id && !postModal) && (
                            <div style={{width: '100%', padding: '0 16px 16px', boxSizing: 'border-box'}}>
                                <div onClick={(togglePostModal)} className='see_more_btn full_width grey'>
                                    <CreateIcon />
                                    <div style={{width: '5px'}}></div>
                                    Write a review
                                </div>
                            </div>
                            // <TweetBox isTablet={isMobile} mobile_redirect={isMobile} isReview />
                        )}
                        
                        {/* Render the post list */}
                        {(filter === 'photos' && post.posts.length > 0) ? (
                            <div style={{width: '100%', height: 'fit-content', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridAutoRows: 'min-content', borderBottom: '1px solid #ddd'}}>
                                
                                {postList}

                                {(!post.no_more_posts && post.posts.length !== 0) && (<Empty_Card last_page_doc={post.last_page_doc} page={"gallery"} loadMore={loadMore} setCanLoadMore={setCanLoadMore} canLoadMore={canLoadMore} />)}
                            </div>
                        ) : postList}

                        {/* Show a spinner at the bottom if more posts are being loaded */}
                        {(post.show_bottom_spinner && !post.no_more_posts && filter !== "photos") && <Spinner />}
                        
                        {/* Render a message when there are no more posts to load */}
                        <div className="no-rides">{(post.no_more_posts && post.posts.length !== 0) && "You've reached the end."}</div>
                        
                        {/* Render a button to create a new post for tablet devices */}
                        {/* {!loading && user ? (
                            isTablet && (
                                <Link to={`/create/post?goBack=${page}`} id="fixed-button" className="show"><AddIcon /></Link>
                            )
                        ) : null} */}
                    </Fragment>
                )}

            </Layout>
        </Fragment>
    )
}

Profile.propTypes = {
    setPage: PropTypes.func.isRequired,
    togglePostModal: PropTypes.func.isRequired,
    add_To_Recent_History: PropTypes.func.isRequired,
    getPostsByUserId: PropTypes.func.isRequired,
    getUserPhotos: PropTypes.func.isRequired,
    getReviewsByUserId: PropTypes.func.isRequired,
    set_ShowBottomSpinner: PropTypes.func.isRequired,
    getLikedPosts: PropTypes.func.isRequired,
    setPosts: PropTypes.func.isRequired,
    getProfileById: PropTypes.func.isRequired,
    editUserName: PropTypes.func.isRequired, 
    editUserBio: PropTypes.func.isRequired, 
    auth: PropTypes.object.isRequired,
    post: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    auth: state.auth,
    post: state.post,
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions from redux to the component
    setPage,
    togglePostModal,
    add_To_Recent_History,
    getPostsByUserId,
    getUserPhotos,
    getLikedPosts,
    getReviewsByUserId,
    set_ShowBottomSpinner,
    setPosts,
    getProfileById,
    editUserName, 
    editUserBio,
})(Profile);
